import { useState, useCallback } from "react";

const DEFAULT_CENTER = {
  lat: 31.771959,
  lng: 35.217018,
};
const DEFAULT_ZOOM = 6;

export function useMapState() {
  const [center, setCenter] = useState<{ lat: number; lng: number }>(() => {
    const saved = localStorage.getItem("mapCenter");
    return saved ? JSON.parse(saved) : DEFAULT_CENTER;
  });

  const [zoom, setZoom] = useState<number>(() => {
    const saved = localStorage.getItem("mapZoom");
    return saved ? parseInt(saved, 10) : DEFAULT_ZOOM;
  });

  const [bounds, setBounds] = useState<google.maps.LatLngBounds | undefined>();

  const updateCenter = useCallback(
    (newCenter: { lat: number; lng: number }) => {
      setCenter(newCenter);
      localStorage.setItem("mapCenter", JSON.stringify(newCenter));
    },
    [],
  );

  const updateZoom = useCallback((newZoom: number) => {
    setZoom(newZoom);
    localStorage.setItem("mapZoom", String(newZoom));
  }, []);

  const updateBounds = useCallback(
    (newBounds: google.maps.LatLngBounds | undefined) => {
      setBounds(newBounds);
    },
    [],
  );

  const handleZoomToLocation = useCallback(
    (location: { lat: number; lng: number }, zoomLevel: number) => {
      updateCenter(location);
      updateZoom(zoomLevel);
    },
    [updateCenter, updateZoom],
  );

  return {
    center,
    zoom,
    bounds,
    updateCenter,
    updateZoom,
    updateBounds,
    handleZoomToLocation,
  };
}
